module.exports = __webpack_public_path__ + "static/media/state-of-the-brew-1.cfb9e0f3.webp";